import {
  Input,
  Component,
  ViewChild,
  ElementRef,
  Renderer2,
  AfterViewInit,
} from '@angular/core';

import { PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements AfterViewInit {

  @ViewChild('header') headerElement: ElementRef;

  @Input('job') job: any;

  headerImg: any = { 'src': 'assets/img/company/hero-img-l.jpg', 'srcSmall': 'assets/img/company/hero-img-s.jpg', 'alt': 'alt-text' };

  constructor(
    private renderer2: Renderer2,
    @Inject(PLATFORM_ID) private platformId: string) { }

  ngAfterViewInit() {

    if (isPlatformServer(this.platformId)) return;

    setTimeout(() => {
      this.renderer2.addClass(this.headerElement.nativeElement, 'shadow-in');
    }, 1000);

  }

  scrollToMap() {
    if (isPlatformServer(this.platformId)) return;

    const targetElement = document.querySelector('#standorte');

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth'
      });
    }

  }

}
